export const EUBA_ALERT_TYPE = {
  ACCESS_AFTER_DISCHARGED: 'AccessAfterDischarged',
  ACCESS_AFTER_LONG_PERIOD: 'AccessAfterLongPeriod',
  ACCESS_OUTSIDE_WORKING_HOURS: 'AccessOutsideWorkingHours',
  EXCESSIVE_ACCESS: 'ExcessiveAccess',
  PROVIDER_FIRST_ACCESS: 'ProviderFirstAccess',
  ACCESS_OUTSIDE_WORKING_DAYS: 'AccessOutsideWorkingDays',
  INACTIVE_PROVIDER_ACCESS: 'InactiveProviderAccess',
}

export const EUBA_ALERT_TYPES = Object.values(EUBA_ALERT_TYPE)

export const RULE_ALERT_TYPE = {
  ACCESS_VIP: 'AccessVIP',
  ACCESS_SELF: 'AccessSelf',
  ACCESS_INTERNAL: 'AccessInternal',
  ACCESS_FAMILY: 'AccessFamily',
  ACCESS_RELATIVES: 'AccessRelatives',
  ACCESS_NEIGHBORS: 'AccessNeighbors',
}

export const RULE_ALERT_TYPES = Object.values(RULE_ALERT_TYPE)

export const ALERT_TYPES = [...EUBA_ALERT_TYPES, ...RULE_ALERT_TYPES] as const

/**
 * Type derived from ALERT_TYPES for type safety
 */
export type AlertType = (typeof ALERT_TYPES)[number]
